module.exports = __webpack_public_path__ + "static/media/muse_nyarubondo_mwogo_road4.605d2f64.jpg";